import React from 'react';

export const TroubleshootingPage: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-6 text-zinc-200">Troubleshooting</h1>

      <p className="text-zinc-400 mb-8">
        Find solutions to common issues and learn how to optimize your Haptic Music Player experience.
      </p>

      <div className="space-y-8">
        <section>
          <h2 className="text-2xl font-semibold mb-4 text-zinc-200">Common Issues</h2>
          
          <div className="space-y-6">
            <div className="bg-zinc-800/50 backdrop-blur p-6 rounded-lg border border-zinc-700/50">
              <h3 className="text-xl font-medium mb-3 text-zinc-200">Audio Playback Issues</h3>
              <ul className="space-y-4">
                <li>
                  <p className="font-medium text-yellow-500">No sound playing</p>
                  <ul className="list-disc list-inside mt-2 text-zinc-400">
                    <li>Check if the volume is muted or too low</li>
                    <li>Verify the correct audio output device is selected</li>
                    <li>Restart the application</li>
                    <li>Check if your audio drivers are up to date</li>
                  </ul>
                </li>
                <li>
                  <p className="font-medium text-yellow-500">Playback stuttering</p>
                  <ul className="list-disc list-inside mt-2 text-zinc-400">
                    <li>Close other resource-intensive applications</li>
                    <li>Lower the audio quality settings</li>
                    <li>Check your system's CPU and memory usage</li>
                  </ul>
                </li>
              </ul>
            </div>

            <div className="bg-zinc-800/50 backdrop-blur p-6 rounded-lg border border-zinc-700/50">
              <h3 className="text-xl font-medium mb-3 text-zinc-200">Haptic Feedback Problems</h3>
              <ul className="space-y-4">
                <li>
                  <p className="font-medium text-yellow-500">No haptic response</p>
                  <ul className="list-disc list-inside mt-2 text-zinc-400">
                    <li>Ensure haptic feedback is enabled in settings</li>
                    <li>Check if your device supports haptic feedback</li>
                    <li>Verify device drivers are installed correctly</li>
                    <li>Try reconnecting your haptic device</li>
                  </ul>
                </li>
                <li>
                  <p className="font-medium text-yellow-500">Weak or inconsistent feedback</p>
                  <ul className="list-disc list-inside mt-2 text-zinc-400">
                    <li>Adjust haptic intensity in settings</li>
                    <li>Check device battery level</li>
                    <li>Update device firmware if available</li>
                  </ul>
                </li>
              </ul>
            </div>

            <div className="bg-zinc-800/50 backdrop-blur p-6 rounded-lg border border-zinc-700/50">
              <h3 className="text-xl font-medium mb-3 text-zinc-200">Performance Issues</h3>
              <ul className="space-y-4">
                <li>
                  <p className="font-medium text-yellow-500">App running slowly</p>
                  <ul className="list-disc list-inside mt-2 text-zinc-400">
                    <li>Clear app cache and temporary files</li>
                    <li>Reduce the size of your music library</li>
                    <li>Update to the latest version</li>
                    <li>Check system resources usage</li>
                  </ul>
                </li>
                <li>
                  <p className="font-medium text-yellow-500">High battery consumption</p>
                  <ul className="list-disc list-inside mt-2 text-zinc-400">
                    <li>Lower haptic feedback intensity</li>
                    <li>Reduce screen brightness</li>
                    <li>Close background applications</li>
                    <li>Enable battery optimization mode</li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4 text-zinc-200">Still Need Help?</h2>
          <div className="bg-zinc-800/50 backdrop-blur p-6 rounded-lg border border-zinc-700/50">
            <p className="text-zinc-400 mb-4">
              If you're still experiencing issues, try these additional resources:
            </p>
            <ul className="list-disc list-inside space-y-2 text-zinc-400">
              <li>Visit our <a href="#" className="text-yellow-500 hover:text-yellow-400">Community Forums</a></li>
              <li>Contact our <a href="#" className="text-yellow-500 hover:text-yellow-400">Support Team</a></li>
              <li>Check our <a href="#" className="text-yellow-500 hover:text-yellow-400">FAQ Section</a></li>
              <li>Follow us on <a href="#" className="text-yellow-500 hover:text-yellow-400">Twitter</a> for updates</li>
            </ul>
          </div>
        </section>
      </div>
    </div>
  );
};
